import { useState } from 'react';
import './App.css';

import { Intro } from './components/intro';
import { Question } from './components/question';
import { Result } from './components/result';

type Step = 'intro' | 'beer' | 'puppy' | 'result';
type Answer = 'yes' | 'no';

interface Answers {
  beer?: Answer;
  puppy?: Answer;
}

function App() {
  const [currentStep, setCurrentStep] = useState<Step>('intro');
  const [answers, setAnswers] = useState<Answers>({});

  const handleAnswer = (question: keyof Answers, answer: Answer) => {
    const newAnswers = { ...answers, [question]: answer };
    setAnswers(newAnswers);
    
    if (question === 'beer') {
      setCurrentStep('puppy');
    } else if (question === 'puppy') {
      setCurrentStep('result');
    }
  };

  const reset = () => {
    setCurrentStep('intro');
    setAnswers({});
  };

  const getResult = () => {
    if (answers.beer === 'yes' && answers.puppy === 'yes') return 'best';
    if (answers.beer === 'yes' && answers.puppy === 'no') return 'better';
    if (answers.beer === 'no' && answers.puppy === 'yes') return 'trustworthy';
    return 'limit';
  };

  const renderIntro = () => <Intro setCurrentStep={setCurrentStep} />;

  const renderQuestion = (question: 'beer' | 'puppy') => {
    return <Question question={question} handleAnswer={handleAnswer} />;
  };

  const renderResult = () => {
    const result = getResult();
    return <Result reset={reset} result={result} />;
  };

  return (
    <div className="App">
      {currentStep === 'intro' && renderIntro()}
      {currentStep === 'beer' && renderQuestion('beer')}
      {currentStep === 'puppy' && renderQuestion('puppy')}
      {currentStep === 'result' && renderResult()}
    </div>
  );
}

export default App;
